import { defineMessages } from 'react-intl-next';

export default defineMessages({
	removeAgentLabel: {
		id: 'ai-mate.inline-chat-input.remove-agent',
		defaultMessage: 'Remove agent',
		description:
			'Accessible label for X button that removes the agent from the chat input on click',
	},
});
